import React from 'react';
import LocalizedStrings from 'react-localization';
import Widget from '../Widget/Widget.js';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label} from 'recharts';
import 'react-table/react-table.css'
import './SavedSearchStackedBarChartWidget.css';

class SavedSearchStackedBarChartWidget extends React.Component {

  constructor(props) {
    super(props);
    this.strings = new LocalizedStrings({
     en:{
       noData: 'No data available'
     },
     de: {
       noData: 'Keine Daten verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  renderXAxis() {
    if(this.props.xAxisLabel && this.props.xAxisLabel !== "") {
      return (
        <XAxis dataKey={this.props.xAxisColumn} height={50} stroke={this.props.xAxisColor}>
         <Label value={this.props.xAxisLabel} position="bottom" offset={-12} stroke={this.props.xAxisColor}/>
        </XAxis>
      )
    } else {
      return (
        <XAxis dataKey={this.props.xAxisColumn} stroke={this.props.xAxisColor}/>
      )
    }
  }

  renderYAxis() {
    if(this.props.yAxisLabel && this.props.yAxisLabel !== "") {
      return (
        <YAxis width={50} stroke={this.props.yAxisColor}>
         <Label value={this.props.yAxisLabel} position="left" offset={-5} angle={-90} stroke={this.props.yAxisColor}/>
        </YAxis>
      )
    } else {
      return (
        <YAxis stroke={this.props.yAxisColor}/>
      )
    }
  }

  renderGridLines() {
    if(this.props.displayGridLines) {
      return (<CartesianGrid strokeDasharray="3 3"/>);
    }
  }

  renderTooltip() {
    if(this.props.displayTooltip) {
      return (<Tooltip wrapperStyle={{color:"black", backgroundColor:"#F5F5F5"}}/>)
    }
  }

  renderLegend() {
    if(this.props.displayLegend) {
      return (<Legend />);
    }
  }

  renderBars() {
    if(this.props.yAxisColumns) {

      return this.props.yAxisColumns.map((column, index) => {
        return (<Bar key={column+"_"+index} dataKey={column} stackId="a" fill={this.props.barColours[column]} />)
      },this)

    }
  }

  renderChart() {
    if(this.props.search && this.props.search.rows && this.props.search.rows.length > 0) {

      const height = (this.props.rowHeight*this.props.size.h) - 120;

      return (
            <ResponsiveContainer width="100%" height={height}>
              <BarChart data={this.props.search.rows}>
               {this.renderXAxis()}
               {this.renderYAxis()}
               {this.renderGridLines()}
               {this.renderTooltip()}
               {this.renderLegend()}
               {this.renderBars()}
              </BarChart>
            </ResponsiveContainer>
      )
    } else {
      return (<h2 className="text-center">{ this.strings.noData }</h2>);
    }
  }

  render() {
    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{this.props.title}</h1>
            {this.renderChart()}
          </div>
        </div>
      </Widget>
    )

  }
}

export default SavedSearchStackedBarChartWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchStackedBarChartWidget/SavedSearchStackedBarChartWidget.js